declare namespace $ {

	export class $mol_icon_menu_up_outline extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=outline.view.tree.d.ts.map